module.exports = __webpack_public_path__ + "static/media/social_awareness.9ce8ed18.png";